import React from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import '../static/NavMenu.css';
import logo from '../static/logo.jpg';
import Button from 'react-bootstrap/Button';
import { useAuth } from './AuthContext';

export const NavMenu = () => {
    const [collapsed, setCollapsed] = React.useState(true);

    const { token, onLogout } = useAuth();

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
                <NavbarBrand tag={Link} to="/">
                    <img src={logo} alt="Logo" width="50px" />
                </NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                    <ul className="navbar-nav flex-grow">
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/">Dashboard</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/domotica">Domotica</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/tictactoe">TicTacToe</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/fetch-data">Weather</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/aboutme">More About Me</NavLink>
                        </NavItem>
                        {token!=null && (
                            <NavItem>
                                <Button variant="outline-success" onClick={onLogout}>Sign Out</Button>
                            </NavItem>)
                        }
                    </ul>
                </Collapse>
            </Navbar>
        </header>
    );
}
